<template>
	<div v-if="currentPage" class="single-heading" :class="mainClass">
        <div class="inner container" :class="{'container--large' : currentPostType === 'page'}">
            <div class="page-featured-image-spacing"  v-if="isFrontPage || (currentPostType === 'page' && featuredImage && !isArchive)" ></div>
            <HeaderBackButton v-if="!isFrontPage" class="padding-top-lg" />
            <PageTitle :key="currentPage.id" />
            <div v-if="subtitle" class="subtitle">
                <p v-html="subtitle" />
            </div>
            <div v-if="excerpt" class="excerpt">
                <p v-html="excerpt"></p>
            </div>
            
            <HomeFIlterLinks class="home-filter padding-top-lg" v-if="isFrontPage" redirect/>
            <HeaderCategories class="margin-bottom-lg padding-top-lg" v-if="!isArchive && (currentPostType === 'professions' || currentPostType === 'educations')"/>
        </div>
        <div v-if="featuredImage && currentPostType !== 'page' && !isArchive" class="thumb-bloq-spacer"></div>
	</div>
</template>

<script>
import HeaderBackButton from '@/components/elements/HeaderBackButton'
import PageTitle from '@/components/parts/PageTitle'
import HeaderCategories from '@/components/elements/HeaderCategories'
import HomeFIlterLinks from '@/components/elements/HomeFIlterLinks'

import { mapGetters } from 'vuex';

export default {
    name: 'single-heading',
    components:{
        PageTitle,
        HeaderBackButton,
        HeaderCategories,
        HomeFIlterLinks
    },
    data(){
        return {}
    },
    computed: {
        ...mapGetters([
            'currentPage',
            'currentPostType',
            'featuredImage',
            'isFrontPage',
            'isArchive'
        ]),
        subtitle(){
            const subtitle = (this.currentPage && this.currentPage.acf && this.currentPage.acf.subtitle) ? this.currentPage.acf.subtitle : ''
            const pre = (this.currentPostType !== 'ambassadors') ? '- ' : '';
            return subtitle ? pre + subtitle : ''
        },
        mainClass(){
            let classMain = []
            if(this.isFrontPage) classMain.push('front-page')
            if(this.isArchive) classMain.push('is-archive')
            if(!this.isArchive) classMain.push('type-'+this.currentPostType)
            return classMain.join(' ')
        },
        excerpt(){
            if(this.isFrontPage && this.currentPage && this.currentPage.acf && this.currentPage.acf.home_banner && this.currentPage.acf.home_banner.description) return this.currentPage.acf.home_banner.description
            return (this.currentPage && this.currentPage.excerpt) ? this.currentPage.excerpt : ''
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.theme-header.has-image{
    .single-heading{
        &.type-page{
           .single-page-title{
            position: relative;
            &:before{
                content: '';
                position: absolute;
                z-index: 10;
                top: -150px;
                bottom: 0;
                background-image: linear-gradient(180deg, rgba(0,87,130,0.00) 0%, #005782 100%);
                width: 200vw;
                z-index: -1;
                @include mquery($phone){
                    top: -75px;
                    width: 100vw;
                }
            }
            
            &:before{
                right: 100vw;
                transform: translateX(100%);
                @include mquery($phone){
                    left: -15px;
                    transform: translateX(0%);
                }
            }
        } 
        }
    }
}
.single-heading{
    background-color: $darkLight;
    color: #fff;
    position: relative;
    z-index: 20;
    &.type-teachers{
        text-align: center;
        .single-page-title, .excerpt{
            margin-left: auto;
            margin-right: auto;
        }
    }
    .subtitle{
        margin-top: -10px;
        @include fluid-type($smallResText, $wideResText, 14px, 20px);
        font-weight: bold;
        padding-bottom: 25px;
        p{
            margin: 0;
        }
    }
    &.is-archive{
        background-color: $light;
        color: $darkLight;
        text-align: center;
        .back-button-holder {
            a{
                color: $darkLight;
                svg{
                    path{
                        fill: $darkLight
                    }
                }
            }
        }
        .excerpt, h1{
            margin-left: auto;
            margin-right: auto;
        }
    }
    &.type-page{
        .page-featured-image-spacing{
            padding-bottom: 28.12%;
        }
        .back-button-holder{
            text-align: left;
        }
        
        .excerpt{
            position: relative;
            background-color: $darkLight;
            padding-bottom: 15px;
            &:after, &:before{
                content: '';
                position: absolute;
                z-index: 10;
                top: 0;
                bottom: 0;
                background-color: $darkLight;
                width: 50vw;
                @include mquery($phone){
                    width: 16px;
                }

            }
            &:after{
                left: 1px;
                transform: translateX(-100%);
            }
            &:before{
                right: 1px;
                transform: translateX(100%);
            }
        }
    }
    &.type-post, &.type-professions, &.type-educations, &.type-ambassadors{
        text-align: center;
        
        .excerpt, .single-page-title{
            margin-left: auto;
            margin-right: auto;
        }
    }
    .thumb-bloq-spacer{
        height: 344px;
		@include mquery(1260px){
            padding-bottom: 28.12%;
            height: 0;
        }
        

    }
    .excerpt{
        max-width: 800px;
        & > p{
            @include fluid-type($smallResText, $wideResText, 14px, 20px);
            margin: 0;
        }
    }
}

</style>
